import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import Layout from '../layout/layout'
import Login from '../login/index'
import mainIndex from '../index/mainIndex'
import en from '../../../i18n/lang/en'
import es from '../../../i18n/lang/es'
import application from '../application/application'
import dataAnalysis from '../data/dataAnalysis'
import config from '../config/config'

//微信访客
import wx_index from '../wechatvisitors/wx_index'
import wx_visit from '../wechatvisitors/wx_visit'
import wx_center from '../wechatvisitors/wx_center'


//微信购票

import wx_ticketIndex from '../wechatlist/wx_ticketIndex'
import wx_ticketList from '../wechatlist/wx_ticketList'
import wx_ticketOrder from '../wechatlist/wx_ticketOrder'
import wx_ticketPay from '../wechatlist/wx_ticketPay'
import wx_ticketUser from '../wechatlist/wx_ticketUser'
import wx_ticketOrderlist from '../wechatlist/wx_ticketOrderlist'
import wx_ticketOrderpay from '../wechatlist/wx_ticketOrderpay'
import wx_ticketOrderTicket from '../wechatlist/wx_ticketOrderTicket'
import wx_ticketOrderQR from '../wechatlist/wx_ticketOrderQR'
import wx_ticketTicket from '../wechatlist/wx_ticketTicket'
import wx_ticketGroup from '../wechatlist/wx_ticketGroup'
import wx_ticketOrderGroup from '../wechatlist/wx_ticketOrderGroup'

//微信小程序

import mn_ticketIndex from '../wechatlistmini/mn_ticketIndex'
import mn_ticketList from '../wechatlistmini/mn_ticketList'
import mn_ticketOrder from '../wechatlistmini/mn_ticketOrder'
import mn_ticketPay from '../wechatlistmini/mn_ticketPay'
import mn_ticketUser from '../wechatlistmini/mn_ticketUser'
import mn_ticketOrderlist from '../wechatlistmini/mn_ticketOrderlist'
import mn_ticketOrderpay from '../wechatlistmini/mn_ticketOrderpay'
import mn_ticketOrderTicket from '../wechatlistmini/mn_ticketOrderTicket'
import mn_ticketOrderQR from '../wechatlistmini/mn_ticketOrderQR'
import mn_ticketTicket from '../wechatlistmini/mn_ticketTicket'
import mn_ticketGroup from '../wechatlistmini/mn_ticketGroup'
import mn_ticketOrderGroup from '../wechatlistmini/mn_ticketOrderGroup'


// 不是必须加载的组件使用懒加载
const NotFound = () =>
    import('../page404')
const data = () =>
    import('../data/data')
const datalista = () =>
    import('../datalist/datalista')
const datalistb = () =>
    import('../datalist/datalistb')
const datalistc = () =>
    import('../datalist/datalistc')



const listStatements = () =>
    import('../data/listStatements')

const listQRStatements = () =>
    import('../data/listQRStatements')
const listQRSlist = () =>
    import('../data/listQRSlist')
const listindex = () =>
    import('../data/listindex')
const listdata = () =>
    import('../data/listdata')
const listticket = () =>
    import('../data/listticket')
const dataStats = () =>
    import('../data/dataStatistics.vue')
const dataReporting = () =>
    import('../data/dataReporting')
const freeChannel = () =>
    import('../data/freeChannel')
const listcard = () =>
    import('../data/listcard')
const listticketOrderTicket = () =>
    import('../data/listticketOrderTicket')
const listQRticket = () =>
    import('../data/listQRticket')
const listgate = () =>
    import('../data/listgate')


const personalCenter = () =>
    import('../personalCenter/personalCenter') // 个人中心
const pagePermissions = () =>
    import('../permissions/pagePermissions')


const parking = () =>
    import('../parking/parking')
const parkingSetup = () =>
    import('../parking/parkingSetup')
const visitorSetup = () =>
    import('../visitor/visitorSetup')
const visitorRegisterRecord = () =>
    import('../visitor/visitorRegisterRecord')
const visitor = () =>
    import('../visitor/visitor')
const access = () =>
    import('../access/access')
const accessSetup = () =>
    import('../access/accessSetup')
const department = () =>
    import('../personnel/department')
const personnel = () =>
    import('../personnel/personnel')
const faceSetup = () =>
    import('../face/faceSetup')
const face = () =>
    import('../face/face')


/* 权限设置 */
const unitsetting = () =>
    import('../setting/unitsetting')
const permissionsetting = () =>
    import('../setting/permissionsetting') // 权限管理
const usersetting = () =>
    import('../setting/usersetting') // 用户管理

const controlTpye = () =>
    import('../control/controlTpye')
const controlVehicle = () =>
    import('../control/controlVehicle')
const vehicleWarning = () =>
    import('../control/vehicleWarning')
const vehicleAcceptance = () =>
    import('../control/vehicleAcceptance')
const controlPersonnel = () =>
    import('../control/controlPersonnel')
const PersonnelWarning = () =>
    import('../control/PersonnelWarning')
const PersonnelAcceptance = () =>
    import('../control/PersonnelAcceptance')
const FaceWarning = () =>
    import('../control/FaceWarning')
const FaceAcceptance = () =>
    import('../control/FaceAcceptance')
const intelligenceWarning = () =>
    import('../control/intelligenceWarning')
const intelligenceAcceptance = () =>
    import('../control/intelligenceAcceptance')
const wechatManagement = () =>
    import('../wechat/wechatManagement')
const wechatMessage = () =>
    import('../wechat/wechatMessage')
const fileMessage = () =>
    import('../file/fileMessage')
const schedulingSettings = () =>
    import('../scheduling/schedulingsettings')
const schedulingadd = () =>
    import('../scheduling/schedulingadd')

const security = () =>
    import('../securitymanagement/security')
const informationregistration = () =>
    import('../information/informationregistration')
/*票务系统路由*/
const tickesSpot = () =>
    import('../ticketSetting/tickesSpot') // 基础设置 -> 景区管理
const ticketScenicname = () =>
    import('../ticketSetting/ticketScenicname') // 基础设置 -> 景点管理
const ticketChecking = () =>
    import('../ticketSetting/ticketChecking')

const ticketGate = () =>
    import('../ticketSetting/ticketGate') // 基础设置 -> 设备管理
const ticketEquipment = () =>
    import('../ticketSetting/ticketEquipment')

/*业务管理*/
const ticketMaking = () =>
    import('../ticketManagement/ticketMaking') // 票类管理
const ticketCard = () =>
    import('../ticketManagement/ticketCard') // 会员卡管理
const ticketStorage = () =>
    import('../ticketManagement/ticketStorage') // 储值卡管理
const ticketAuthentication = () =>
    import('../ticketManagement/ticketAuthentication') // 人证核验
const ticketMerchandise = () =>
    import('../ticketManagement/ticketMerchandise')
const ticketMerchandisekind = () =>
    import('../ticketManagement/ticketMerchandisekind')
const ticketPreferential = () =>
    import('../ticketManagement/ticketPreferential') // 票类优惠管理
const ticketMatchingRules = () =>
    import('../ticketManagement/ticketMatchingRules') // 票种匹配规则
const ticketCompensationPrice = () =>
    import('../ticketManagement/ticketCompensationPrice') // 差价规则管理
const ticketBilling = () =>
    import('../ticketManagement/ticketBilling') // 计费管理
const ticketTime = () =>
    import('../ticketManagement/ticketTime') // 通行日程管理
const ticketGroup = () =>
    import('../ticketManagement/ticketGroup')
const ticketCalendar = () =>
    import('../ticketManagement/ticketCalendar')
const ticketControl = () =>
    import('../ticketManagement/ticketControl') // 区域管控
const ticketTimeSharing = () =>
    import('../ticketManagement/ticketTimeSharing') //
const print = () =>
    import('../ticketManagement/print') // 打印管理

/*股东设置*/
const Shareholder = () =>
    import('../shareholder/Shareholder') // 股东管理
const Share = () =>
    import('../shareholder/Share') // 股东权益
const Statement = () =>
    import('../shareholder/Statement') // 收益明细




/* 库存管理 */
const Entry = () =>
    import('../warehouse/Entry') // 门票录入
const Ticket_Inventory = () =>
    import('../warehouse/Ticket_Inventory') // 门票库存

/*领票管理*/
const ticketWarehouseManagement = () =>
    import('../ticketCollection/ticketWarehouseManagement') // 票库管理
const ticketCollectionManagement = () =>
    import('../ticketCollection/ticketCollectionManagement') // 领票管理
const returnManagement = () =>
    import('../ticketCollection/returnManagement') // 退库管理
const dataStatistics = () =>
    import('../ticketCollection/dataStatistics') // 数据统计

/*商品管理*/
const commodity = () =>
    import('../goods/commodity') // 商品明细
const gatalogue = () =>
    import('../goods/gatalogue') // 商品目录
const shops = () =>
    import('../goods/shops') // 商铺管理
const goodsloading = () =>
    import('../goods/goodsloading') // 商品录入
const Inventory = () =>
    import('../goods/Inventory')  // 商品库存明细
const Commoditysales = () =>
    import('../goods/Commoditysales') // 商品订单明细
const Salesdetails = () =>
    import('../goods/Salesdetails') // 商品销售明细


/*场馆管理*/
const ticketVenuesetup = () =>
    import('../ticketVenue/ticketVenuesetup')
const ticketVenueplan = () =>
    import('../ticketVenue/ticketVenueplan')

/*查询报表*/
const ticketrOrder = () =>
    import('../ticketReport/ticketrOrder') // 订单明细
const ticketTicket = () =>
    import('../ticketReport/ticketTicket') // 票明细
const ticketCode = () =>
    import('../ticketReport/ticketCode') // 验证明细
const ticketImport = () =>
    import('../ticketReport/ticketImport') // 进出明细
const ticketConsume = () =>
    import('../ticketReport/ticketConsume') // 会员刷卡明细
const ticketActivate = () =>
    import('../ticketReport/ticketActivate') // 会员激活明细
const ticketConsumestate = () =>
    import('../ticketReport/ticketConsumestate') // 未使用明细
const ticketInventory = () =>
    import('../ticketReport/ticketInventory')
const ticketMerchandiseReport = () =>
    import('../ticketReport/ticketMerchandiseReport')
const ticketMerchandiseSale = () =>
    import('../ticketReport/ticketMerchandiseSale')
const ticketFlow = () =>
    import('../ticketReport/ticketFlow') // 来源明细
const ticketStorageReport = () =>
    import('../ticketReport/ticketStorageReport')
const Supplementary = () =>
    import('../ticketReport/Supplementary') // 补取明细
const ticketRefund = () =>
    import('../ticketReport/ticketRefund') // 退票明细
const statisticAnalysis = () =>
    import('../ticketReport/statisticAnalysis') // 统计分析

/*查询报表*/
const ticketCommodity = () =>
    import('../ticketInput/ticketCommodity')
const ticketType = () =>
    import('../ticketInput/ticketType')
/*系统信息*/
const ticketWechat = () =>
    import('../ticketsystem/ticketWechat') // 微信设置
const ticketAlipay = () =>
    import('../ticketsystem/ticketAlipay') // 支付宝设置
const ticketDatabase = () =>
    import('../ticketsystem/ticketDatabase')
const ticketInformation = () =>
    import('../ticketsystem/ticketInformation') // 系统信息
const ticketLog = () =>
    import('../ticketsystem/ticketLog') // 日志管理
const EquipmentUpgrade = () =>
    import('../ticketsystem/EquipmentUpgrade') // 设备升级

const programRelease = () =>
    import('../release/programRelease') // 节目设置
const graphicRelease = () =>
    import('../release/graphicRelease') // 视频图文设置
const contentRelease = () =>
    import('../release/contentRelease')
const dataRelease = () =>
    import('../release/dataRelease') // 数据看板展示


const travelAgencyManagement = () =>
    import('../travelAgencyManagement/travelAgencyManagement') // 旅行社管理
const ticketTypeManagement = () =>
    import('../travelAgencyManagement/ticketTypeManagement') // 票类管理
const orderManagement = () =>
    import('../travelAgencyManagement/orderManagement') // 订单管理
const rechargeManagement = () =>
    import('../travelAgencyManagement/rechargeManagement') // 充值管理
const userManagement = () =>
    import('../travelAgencyManagement/userManagement') // 用户管理
const financialStatements = () =>
    import('../travelAgencyManagement/financialStatements') // 财务报表
// const test = () =>
//     import('../travelAgencyManagement/test') // 测试

/* AI客流管理 */
const camera = () =>
    import('../passenger/camera') // NVR设置
const statistics = () =>
    import('../passenger/statistics') // 客流分析

/*数据中心*/
const datalist = () =>
    import('../datalist/datalist')
/*财务报表*/
const ticketStatements = () =>
    import('../ticketStatements/ticketStatements')
/*售票*/
const sellPrintTickets = () =>
    import('../sellPrintTickets/sellPrintTickets')
const sellPrintTicketsgoods = () =>
    import('../sellPrintTicketsgoods/sellPrintTicketsgoods')



const sellScanningTicketing = () =>
    import('../sellScanningTicketing/sellScanningTicketing')
const sellMembershipCard = () =>
    import('../sellMembershipCard/sellMembershipCard')
const sellStoredCard = () =>
    import('../sellStoredCard/sellStoredCard')
const sellRefund = () =>
    import('../sellRefund/sellRefund')
const sellCollection = () =>
    import('../sellCollection/sellCollection')
const sellDifference = () =>
    import('../sellDifference/sellDifference')
const sellgoods = () =>
    import('../sellgoods/sellgoods')
const scan = () =>
    import('../sellscan/scan')

const sellRecord = () =>
    import('../sellRecord/sellRecord')
const travelAgencyOrderManagement = () =>
    import('../travelAgencyOrderManagement/travelAgencyOrderManagement')
/*门票详情记录*/
const ticketDetailsRecord = () =>
    import('../ticketDetailsRecord/ticketDetailsRecord')
const sellQuery = () =>
    import('../sellQuery/sellQuery')
const sellMemberrenewal = () =>
    import('../sellMemberrenewal/sellMemberrenewal')
const annualCardActivation = () =>
    import('../annualCardActivation/annualCardActivation')


import importOrder from '../travelAgencyMenu/importOrder'
const travelAgencyOrderManagement_travelAgency = () =>
    import('../travelAgencyMenu/travelAgencyOrderManagement')
const travelAgencyRechargeManagement = () =>
    import('../travelAgencyMenu/travelAgencyRechargeManagement')




Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

let routeName = en.routeName
let defaultRouter = [{
    id: '101',
    path: '/login',
    component: Login,
    hidden: true,
    children: []
},
{
    id: '102',
    path: '/data',
    component: data,
    hidden: true,
    children: []
},
{
    id: '105',
    path: '/datalista',
    component: datalista,
    hidden: true,
    children: []
},
{
    id: '106',
    path: '/datalistb',
    component: datalistb,
    hidden: true,
    children: []
},
{
    id: '107',
    path: '/datalistc',
    component: datalistc,
    hidden: true,
    children: []
},

{
    id: '107',
    path: '/listindex',
    component: listindex,
    hidden: true,
    children: []
},
{
    id: '107',
    path: '/listcard',
    component: listcard,
    hidden: true,
    children: []
},
{
    id: '107',
    path: '/listdata',
    component: listdata,
    hidden: true,
    children: []
},
{
    id: '107',
    path: '/listgate',
    component: listgate,
    hidden: true,
    children: []
},
{
    id: '108',
    path: '/listStatements',
    component: listStatements,
    hidden: true,
    children: []
},
{
    id: '1010',
    path: '/listQRStatements',
    component: listQRStatements,
    hidden: true,
    children: []
},

{
    id: '109',
    path: '/listQRSlist',
    component: listQRSlist,
    hidden: true,
    children: []
},
{
    id: '109',
    path: '/listticket',
    component: listticket,
    hidden: true,
    children: []
},
{
    id: '1011',
    path: '/dataStats',
    component: dataStats,
    hidden: true,
    children: []
},
{
    id: '1011',
    path: '/dataReporting',
    component: dataReporting,
    hidden: true,
    children: []
},
{
    id: '1011',
    path: '/freeChannel',
    component: freeChannel,
    hidden: true,
    children: []
},
{
    id: '101',
    path: '/listticketOrderTicket',
    component: listticketOrderTicket,
    hidden: true,
    children: []
},

{
    id: '101',
    path: '/listQRticket',
    component: listQRticket,
    hidden: true,
    children: []
},

{
    id: '103',
    path: '/dataAnalysis', //数据分析
    component: dataAnalysis,
    hidden: true,
    children: []
},

{
    id: '104',
    path: '/config', //配置
    component: config,
    hidden: true,
    children: []
},
{
    path: '/wx_index', //微信公众号页面
    component: wx_index,
    hidden: true,
    children: []
},
{
    path: '/wx_visit', //
    component: wx_visit,
    hidden: true,
    children: []
},
{
    path: '/wx_center', //
    component: wx_center,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketIndex', //
    component: wx_ticketIndex,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketList', //
    component: wx_ticketList,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketGroup', //
    component: wx_ticketGroup,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketOrderGroup', //
    component: wx_ticketOrderGroup,
    hidden: true,
    children: []
},

{
    path: '/wx_ticketOrder', //
    component: wx_ticketOrder,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketPay', //
    component: wx_ticketPay,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketUser', //
    component: wx_ticketUser,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketOrderpay', //
    component: wx_ticketOrderpay,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketOrderlist', //
    component: wx_ticketOrderlist,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketOrderQR', //
    component: wx_ticketOrderQR,
    hidden: true,
    children: []
},

{
    path: '/wx_ticketOrderTicket', //
    component: wx_ticketOrderTicket,
    hidden: true,
    children: []
},
{
    path: '/wx_ticketTicket', //
    component: wx_ticketTicket,
    hidden: true,
    children: []
},


{
    path: '/mn_ticketIndex', ////微信小程序
    component: mn_ticketIndex,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketList', //
    component: mn_ticketList,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketGroup', //
    component: mn_ticketGroup,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketOrderGroup', //
    component: mn_ticketOrderGroup,
    hidden: true,
    children: []
},

{
    path: '/mn_ticketOrder', //
    component: mn_ticketOrder,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketPay', //
    component: mn_ticketPay,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketUser', //
    component: mn_ticketUser,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketOrderpay', //
    component: mn_ticketOrderpay,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketOrderlist', //
    component: mn_ticketOrderlist,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketOrderQR', //
    component: mn_ticketOrderQR,
    hidden: true,
    children: []
},

{
    path: '/mn_ticketOrderTicket', //
    component: mn_ticketOrderTicket,
    hidden: true,
    children: []
},
{
    path: '/mn_ticketTicket', //
    component: mn_ticketTicket,
    hidden: true,
    children: []
},
{
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
    children: []
}
]

let storage = window.sessionStorage;
let ticketSetting1 = storage.getItem("ticketSetting1");
let ticketSetting2 = storage.getItem("ticketSetting2");
let ticketSetting3 = storage.getItem("ticketSetting3");
let ticketSetting4 = storage.getItem("ticketSetting4");
let ticketSetting5 = storage.getItem("ticketSetting5");
let ticketSetting6 = storage.getItem("ticketSetting6");
let addRouterticketSetting2 = {};
let addRouterticketSetting3 = {};
let addRouterticketSetting4 = {};
let addRouterticketSetting5 = {};
let addRouterticketSetting6 = {};

if (ticketSetting2 == 1) {
    addRouterticketSetting2 = {
        path: '/tickesSpot',
        iconCls: 'fa el-icon-s-home',
        name: routeName.tickesSpot,
        component: tickesSpot,
        hidden: false,
        children: []
    }
} else {
    addRouterticketSetting2 = {
        path: '/tickesSpot',
        iconCls: 'fa el-icon-s-home',
        name: routeName.tickesSpot,
        component: tickesSpot,
        hidden: true,
        children: []
    }
}
if (ticketSetting3 == 1) {
    addRouterticketSetting3 = {
        path: '/ticketScenicname',
        iconCls: 'fa el-icon-s-flag',
        name: routeName.ticketScenicname,
        component: ticketScenicname,
        hidden: false,
        children: []
    }
} else {
    addRouterticketSetting3 = {
        path: '/ticketScenicname',
        iconCls: 'fa el-icon-s-flag',
        name: routeName.ticketScenicname,
        component: ticketScenicname,
        hidden: true,
        children: []
    }
}
if (ticketSetting4 == 1) {
    addRouterticketSetting4 = {
        path: '/ticketChecking',
        iconCls: 'fa el-icon-s-shop',
        name: routeName.ticketChecking,
        component: ticketChecking,
        hidden: true,
        children: []
    }
} else {
    addRouterticketSetting4 = {
        path: '/ticketChecking',
        iconCls: 'fa el-icon-s-shop',
        name: routeName.ticketChecking,
        component: ticketChecking,
        hidden: true,
        children: []
    }
}
if (ticketSetting5 == 1) {
    addRouterticketSetting5 = {
        path: '/ticketGate',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.ticketGate,
        component: ticketGate,
        hidden: false,
        children: []
    }
} else {
    addRouterticketSetting5 = {
        path: '/ticketGate',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.ticketGate,
        component: ticketGate,
        hidden: true,
        children: []
    }
}
if (ticketSetting6 == 1) {
    addRouterticketSetting6 = {
        path: '/ticketEquipment',
        iconCls: 'fa el-icon-s-opportunity',
        name: routeName.ticketEquipment,
        component: ticketEquipment,
        hidden: false,
        children: []
    }
} else {
    addRouterticketSetting6 = {
        path: '/ticketEquipment',
        iconCls: 'fa el-icon-s-opportunity',
        name: routeName.ticketEquipment,
        component: ticketEquipment,
        hidden: true,
        children: []
    }
}

let ticketManagement1 = storage.getItem("ticketManagement1");
let ticketManagement2 = storage.getItem("ticketManagement2");
let ticketManagement3 = storage.getItem("ticketManagement3");
let ticketManagement4 = storage.getItem("ticketManagement4");
let ticketManagement5 = storage.getItem("ticketManagement5");
let ticketManagement6 = storage.getItem("ticketManagement6");
let ticketManagement7 = storage.getItem("ticketManagement7");
let ticketManagement8 = storage.getItem("ticketManagement8");
let ticketManagement9 = storage.getItem("ticketManagement9");
let ticketManagement10 = storage.getItem("ticketManagement10");
let ticketManagement11 = storage.getItem("ticketManagement11");
let ticketManagement12 = storage.getItem("ticketManagement12");
let ticketManagement13 = storage.getItem("ticketManagement13");
let ticketManagement14 = storage.getItem("ticketManagement14");
let ticketManagement15 = storage.getItem("ticketManagement15");
let ticketManagement16 = storage.getItem("ticketManagement16");


let addRouterticketManagement2 = {};
let addRouterticketManagement3 = {};
let addRouterticketManagement4 = {};
let addRouterticketManagement5 = {};
let addRouterticketManagement6 = {};
let addRouterticketManagement7 = {};
let addRouterticketManagement8 = {};
let addRouterticketManagement9 = {};
let addRouterticketManagement10 = {};
let addRouterticketManagement11 = {};
let addRouterticketManagement13 = {};
let addRouterticketManagement12 = {};
let addRouterticketManagement14 = {};
let addRouterticketManagement15 = {};
let addRouterticketManagement16 = {};

if (ticketManagement2 == 1) {
    addRouterticketManagement2 = {
        path: '/ticketMaking',
        iconCls: 'fa el-icon-s-management',
        name: routeName.ticketMaking,
        component: ticketMaking,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement2 = {
        path: '/ticketMaking',
        iconCls: 'fa el-icon-s-management',
        name: routeName.ticketMaking,
        component: ticketMaking,
        hidden: true,
        children: []
    }
}
if (ticketManagement3 == 1) {
    addRouterticketManagement3 = {
        path: '/ticketCard',
        iconCls: 'fa el-icon-bank-card',
        name: routeName.ticketCard,
        component: ticketCard,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement3 = {
        path: '/ticketCard',
        iconCls: 'fa el-icon-bank-card',
        name: routeName.ticketCard,
        component: ticketCard,
        hidden: true,
        children: []
    }
}
if (ticketManagement4 == 1) {
    addRouterticketManagement4 = {
        path: '/ticketStorage',
        iconCls: 'fa el-icon-money',
        name: routeName.ticketStorage,
        component: ticketStorage,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement4 = {
        path: '/ticketStorage',
        iconCls: 'fa el-icon-money',
        name: routeName.ticketStorage,
        component: ticketStorage,
        hidden: true,
        children: []
    }
}
if (ticketManagement5 == 1) {
    addRouterticketManagement5 = {
        path: '/ticketAuthentication',
        iconCls: 'fa el-icon-user-solid',
        name: routeName.ticketAuthentication,
        component: ticketAuthentication,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement5 = {
        path: '/ticketAuthentication',
        iconCls: 'fa el-icon-user-solid',
        name: routeName.ticketAuthentication,
        component: ticketAuthentication,
        hidden: true,
        children: []
    }
}
if (ticketManagement6 == 1) {
    addRouterticketManagement6 = {
        path: '/ticketMerchandise',
        iconCls: 'fa el-icon-video-camera-solid',
        name: routeName.ticketMerchandise,
        component: ticketMerchandise,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement6 = {
        path: '/ticketMerchandise',
        iconCls: 'fa el-icon-video-camera-solid',
        name: routeName.ticketMerchandise,
        component: ticketMerchandise,
        hidden: true,
        children: []
    }
}
if (ticketManagement7 == 1) {
    addRouterticketManagement7 = {
        path: '/ticketMerchandisekind',
        iconCls: 'fa el-icon-s-goods',
        name: routeName.ticketMerchandisekind,
        component: ticketMerchandisekind,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement7 = {
        path: '/ticketMerchandisekind',
        iconCls: 'fa el-icon-s-goods',
        name: routeName.ticketMerchandisekind,
        component: ticketMerchandisekind,
        hidden: true,
        children: []
    }
}
if (ticketManagement8 == 1) {
    addRouterticketManagement8 = {
        path: '/ticketPreferential',
        iconCls: 'fa el-icon-goods',
        name: routeName.ticketPreferential,
        component: ticketPreferential,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement8 = {
        path: '/ticketPreferential',
        iconCls: 'fa el-icon-goods',
        name: routeName.ticketPreferential,
        component: ticketPreferential,
        hidden: true,
        children: []
    }
}
if (ticketManagement9 == 1) {
    addRouterticketManagement9 = {
        path: '/ticketCompensationPrice',
        iconCls: 'fa el-icon-picture-outline',
        name: routeName.ticketCompensationPrice,
        component: ticketCompensationPrice,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement9 = {
        path: '/ticketCompensationPrice',
        iconCls: 'fa el-icon-picture-outline',
        name: routeName.ticketCompensationPrice,
        component: ticketCompensationPrice,
        hidden: true,
        children: []
    }
}
if (ticketManagement10 == 1) {
    addRouterticketManagement10 = {
        path: '/ticketBilling',
        iconCls: 'fa el-icon-money',
        name: routeName.ticketBilling,
        component: ticketBilling,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement10 = {
        path: '/ticketBilling',
        iconCls: 'fa el-icon-moneyr',
        name: routeName.ticketBilling,
        component: ticketBilling,
        hidden: true,
        children: []
    }
}
if (ticketManagement11 == 1) {
    addRouterticketManagement11 = {
        path: '/ticketTime',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketTime,
        component: ticketTime,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement11 = {
        path: '/ticketTime',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketTime,
        component: ticketTime,
        hidden: true,
        children: []
    }
}
if (ticketManagement13 == 1) {
    addRouterticketManagement13 = {
        path: '/ticketGroup',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketGroup,
        component: ticketGroup,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement13 = {
        path: '/ticketGroup',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketGroup,
        component: ticketGroup,
        hidden: true,
        children: []
    }
}
if (ticketManagement12 == 1) {
    addRouterticketManagement12 = {
        path: '/ticketCalendar',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketCalendar,
        component: ticketCalendar,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement12 = {
        path: '/ticketCalendar',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketCalendar,
        component: ticketCalendar,
        hidden: true,
        children: []
    }
}
if (ticketManagement14 == 1) {
    addRouterticketManagement14 = {
        path: '/ticketControl',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketControl,
        component: ticketControl,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement14 = {
        path: '/ticketControl',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketControl,
        component: ticketControl,
        hidden: true,
        children: []
    }
}
if (ticketManagement15 == 1) {
    addRouterticketManagement15 = {
        path: '/ticketTimeSharing',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketTimeSharing,
        component: ticketTimeSharing,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement15 = {
        path: '/ticketTimeSharing',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketTimeSharing,
        component: ticketTimeSharing,
        hidden: true,
        children: []
    }
}
if (ticketManagement16 == 1) {
    addRouterticketManagement16 = {
        path: '/ticketMatchingRules',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketMatchingRules,
        component: ticketMatchingRules,
        hidden: false,
        children: []
    }
} else {
    addRouterticketManagement16 = {
        path: '/ticketMatchingRules',
        iconCls: 'fa el-icon-folder',
        name: routeName.ticketMatchingRules,
        component: ticketMatchingRules,
        hidden: true,
        children: []
    }
}
let setting1 = storage.getItem("setting1");
/*let setting2 =storage.getItem("setting2");*/
let setting3 = storage.getItem("setting3");
let setting4 = storage.getItem("setting4");
let setting5 = storage.getItem("setting5");
let addRoutersetting2 = {};
let addRoutersetting3 = {};
let addRoutersetting4 = {};
let addRoutersetting5 = {};
/*if(setting2==1){
     addRoutersetting2={
        path: '/unitsetting',
        iconCls: 'fa el-icon-user-solid',
        name: routeName.unitsetting,
        component: unitsetting,
        hidden: false,
        children: []
     }
}else{
  addRoutersetting2={
        path: '/unitsetting',
        iconCls: 'fa el-icon-user-solid',
        name: routeName.unitsetting,
        component: unitsetting,
        hidden: true,
        children: []
     }
}*/
if (setting3 == 1) {
    addRoutersetting3 = {
        path: '/permissionsetting',
        iconCls: 'fa el-icon-s-check',
        name: routeName.permissionsetting,
        component: permissionsetting,
        hidden: false,
        children: []
    }
} else {
    addRoutersetting3 = {
        path: '/permissionsetting',
        iconCls: 'fa el-icon-s-check',
        name: routeName.permissionsetting,
        component: permissionsetting,
        hidden: true,
        children: []
    }
}
if (setting4 == 1) {
    addRoutersetting4 = {
        path: '/usersetting',
        iconCls: 'fa fa-address-book',
        name: routeName.usersetting,
        component: usersetting,
        children: []
    }
} else {
    addRoutersetting4 = {
        path: '/usersetting',
        iconCls: 'fa fa-address-book',
        name: routeName.usersetting,
        component: usersetting,
        hidden: true,
        children: []
    }
}
if (setting5 == 1) {
    addRoutersetting5 = {
        path: '/print',
        iconCls: 'fa el-icon-printer',
        name: routeName.print,
        component: print,
        children: []
    }
} else {
    addRoutersetting5 = {
        path: '/print',
        iconCls: 'fa el-icon-printer',
        name: routeName.print,
        component: print,
        hidden: true,
        children: []
    }
}

let ticketVenue1 = storage.getItem("ticketVenue1");
let ticketVenue2 = storage.getItem("ticketVenue2");
let ticketVenue3 = storage.getItem("ticketVenue3");
let addRouterticketVenue2 = {};
let addRouterticketVenue3 = {};

if (ticketVenue2 == 1) {
    addRouterticketVenue3 = {
        path: '/ticketVenuesetup',
        iconCls: 'fa el-icon-tickets',
        name: routeName.ticketVenuesetup,
        component: print,
        children: []
    }
} else {
    addRouterticketVenue3 = {
        path: '/print',
        iconCls: 'fa el-icon-tickets',
        name: routeName.ticketVenuesetup,
        component: ticketVenuesetup,
        hidden: true,
        children: []
    }
}
if (ticketVenue3 == 1) {
    addRouterticketVenue2 = {
        path: '/ticketVenueplan',
        iconCls: 'fa el-icon-document-add',
        name: routeName.ticketVenueplan,
        component: ticketVenueplan,
        children: []
    }
} else {
    addRouterticketVenue2 = {
        path: '/ticketVenueplan',
        iconCls: 'fa el-icon-document-add',
        name: routeName.ticketVenueplan,
        component: ticketVenueplan,
        hidden: true,
        children: []
    }
}
let ticketReport1 = storage.getItem("ticketReport1");
let ticketReport2 = storage.getItem("ticketReport2");
let ticketReport3 = storage.getItem("ticketReport3");
let ticketReport4 = storage.getItem("ticketReport4");
let ticketReport5 = storage.getItem("ticketReport5");
let ticketReport6 = storage.getItem("ticketReport6");
let ticketReport7 = storage.getItem("ticketReport7");
let ticketReport8 = storage.getItem("ticketReport8");
let ticketReport9 = storage.getItem("ticketReport9");
let ticketReport10 = storage.getItem("ticketReport10");
let ticketReport11 = storage.getItem("ticketReport11");
let ticketReport12 = storage.getItem("ticketReport12");
let ticketReport13 = storage.getItem("ticketReport13");
let ticketReport14 = storage.getItem("ticketReport14");
let ticketReport15 = storage.getItem("ticketReport15");
let ticketReport16 = storage.getItem("ticketReport16");

let addRouterticketReport2 = {};
let addRouterticketReport3 = {};
let addRouterticketReport4 = {};
let addRouterticketReport5 = {};
let addRouterticketReport6 = {};
let addRouterticketReport7 = {};
let addRouterticketReport8 = {};
let addRouterticketReport9 = {};
let addRouterticketReport13 = {};
let addRouterticketReport10 = {};
let addRouterticketReport11 = {};
let addRouterticketReport12 = {};
let addRouterticketReport14 = {};
let addRouterticketReport15 = {};
let addRouterticketReport16 = {};
if (ticketReport2 == 1) {
    addRouterticketReport2 = {
        path: '/ticketrOrder',
        iconCls: 'fa el-icon-reading',
        name: routeName.ticketrOrder,
        component: ticketrOrder,
        children: []
    }
} else {
    addRouterticketReport2 = {
        path: '/ticketrOrder',
        iconCls: 'fa el-icon-reading',
        name: routeName.ticketrOrder,
        component: ticketrOrder,
        hidden: true,
        children: []
    }
}
// if (ticketReport2 == 1) {
//     addRouterticketReport2 = {
//         path: '/ticketrOrder',
//         iconCls: 'fa el-icon-reading',
//         name: routeName.ticketrOrder,
//         component: ticketrOrder,
//         meta: {
//             keepAlive: true
//         },
//         children: []
//     }
// } else {
//     addRouterticketReport2 = {
//         path: '/ticketrOrder',
//         iconCls: 'fa el-icon-reading',
//         name: routeName.ticketrOrder,
//         component: ticketrOrder,
//         meta: {
//             keepAlive: true
//         },
//         hidden: true,
//         children: []
//     }
// }
if (ticketReport3 == 1) {
    addRouterticketReport3 = {
        path: '/ticketTicket',
        iconCls: 'fa el-icon-s-fold',
        name: routeName.ticketTicket,
        component: ticketTicket,
        children: []
    }
} else {
    addRouterticketReport3 = {
        path: '/ticketTicket',
        iconCls: 'fa el-icon-s-fold',
        name: routeName.ticketTicket,
        component: ticketTicket,
        hidden: true,
        children: []
    }
}
if (ticketReport4 == 1) {
    addRouterticketReport4 = {
        path: '/ticketCode',
        iconCls: 'fa el-icon-s-unfold',
        name: routeName.ticketCode,
        component: ticketCode,
        children: []
    }
} else {
    addRouterticketReport4 = {
        path: '/ticketCode',
        iconCls: 'fa el-icon-s-unfold',
        name: routeName.ticketCode,
        component: ticketCode,
        hidden: true,
        children: []
    }
}
if (ticketReport5 == 1) {
    addRouterticketReport5 = {
        path: '/ticketImport',
        iconCls: 'fa el-icon-s-operation',
        name: routeName.ticketImport,
        component: ticketImport,
        children: []
    }
} else {
    addRouterticketReport5 = {
        path: '/ticketImport',
        iconCls: 'fa el-icon-s-operation',
        name: routeName.ticketImport,
        component: ticketImport,
        hidden: true,
        children: []
    }
}

if (ticketReport6 == 1) {
    addRouterticketReport6 = {
        path: '/ticketConsume',
        iconCls: 'fa el-icon-s-release',
        name: routeName.ticketConsume,
        component: ticketConsume,
        children: []
    }
} else {
    addRouterticketReport6 = {
        path: '/ticketConsume',
        iconCls: 'fa el-icon-s-release',
        name: routeName.ticketConsume,
        component: ticketConsume,
        hidden: true,
        children: []
    }
}

if (ticketReport7 == 1) {
    addRouterticketReport7 = {
        path: '/ticketConsumestate',
        iconCls: 'fa el-icon-s-grid',
        name: routeName.ticketConsumestate,
        component: ticketConsumestate,
        children: []
    }
} else {
    addRouterticketReport7 = {
        path: '/ticketConsumestate',
        iconCls: 'fa el-icon-s-grid',
        name: routeName.ticketConsumestate,
        component: ticketConsumestate,
        hidden: true,
        children: []
    }
}
if (ticketReport8 == 1) {
    addRouterticketReport8 = {
        path: '/ticketInventory',
        iconCls: 'fa el-icon-menu',
        name: routeName.ticketInventory,
        component: ticketInventory,
        children: []
    }
} else {
    addRouterticketReport8 = {
        path: '/ticketInventory',
        iconCls: 'fa el-icon-menu',
        name: routeName.ticketInventory,
        component: ticketInventory,
        hidden: true,
        children: []
    }
}
if (ticketReport9 == 1) {
    addRouterticketReport9 = {
        path: '/ticketMerchandiseReport',
        iconCls: 'fa el-icon-c-scale-to-original',
        name: routeName.ticketMerchandiseReport,
        component: ticketMerchandiseReport,
        children: []
    }
} else {
    addRouterticketReport9 = {
        path: '/ticketMerchandiseReport',
        iconCls: 'fa el-icon-c-scale-to-original',
        name: routeName.ticketMerchandiseReport,
        component: ticketMerchandiseReport,
        hidden: true,
        children: []
    }
}
if (ticketReport10 == 1) {
    addRouterticketReport10 = {
        path: '/ticketMerchandiseSale',
        iconCls: 'fa el-icon-document-remove',
        name: routeName.ticketMerchandiseSale,
        component: ticketMerchandiseSale,
        children: []
    }
} else {
    addRouterticketReport10 = {
        path: '/ticketMerchandiseSale',
        iconCls: 'fa el-icon-document-remove',
        name: routeName.ticketMerchandiseSale,
        component: ticketMerchandiseSale,
        hidden: true,
        children: []
    }
}
if (ticketReport11 == 1) {
    addRouterticketReport11 = {
        path: '/ticketFlow',
        iconCls: 'fa el-icon-wallet',
        name: routeName.ticketFlow,
        component: ticketFlow,
        children: []
    }
} else {
    addRouterticketReport11 = {
        path: '/ticketFlow',
        iconCls: 'fa el-icon-wallet',
        name: routeName.ticketFlow,
        component: ticketFlow,
        hidden: true,
        children: []
    }
}
if (ticketReport12 == 1) {
    addRouterticketReport12 = {
        path: '/ticketStorageReport',
        iconCls: 'fa el-icon-notebook-1',
        name: routeName.ticketStorageReport,
        component: ticketStorageReport,
        children: []
    }
} else {
    addRouterticketReport12 = {
        path: '/ticketStorageReport',
        iconCls: 'fa el-icon-notebook-1',
        name: routeName.ticketStorageReport,
        component: ticketStorageReport,
        hidden: true,
        children: []
    }
}

if (ticketReport13 == 1) {
    addRouterticketReport13 = {
        path: '/Supplementary',
        iconCls: 'fa el-icon-c-scale-to-original',
        name: routeName.Supplementary,
        component: Supplementary,
        children: []
    }
} else {
    addRouterticketReport13 = {
        path: '/Supplementary',
        iconCls: 'fa el-icon-c-scale-to-original',
        name: routeName.Supplementary,
        component: Supplementary,
        hidden: true,
        children: []
    }
}

if (ticketReport14 == 1) {
    addRouterticketReport14 = {
        path: '/ticketRefund',
        iconCls: 'fa el-icon-document-checked',
        name: routeName.ticketRefund,
        component: ticketRefund,
        children: []
    }
} else {
    addRouterticketReport14 = {
        path: '/ticketRefund',
        iconCls: 'fa el-icon-document-checked',
        name: routeName.ticketRefund,
        component: ticketRefund,
        hidden: true,
        children: []
    }
}
if (ticketReport15 == 1) {
    addRouterticketReport15 = {
        path: '/statisticAnalysis',
        iconCls: 'fa el-icon-document-checked',
        name: routeName.statisticAnalysis,
        component: statisticAnalysis,
        children: []
    }
} else {
    addRouterticketReport15 = {
        path: '/statisticAnalysis',
        iconCls: 'fa el-icon-document-checked',
        name: routeName.statisticAnalysis,
        component: statisticAnalysis,
        hidden: true,
        children: []
    }
}
if (ticketReport16 == 1) {
    addRouterticketReport16 = {
        path: '/ticketActivate',
        iconCls: 'fa el-icon-document-checked',
        name: routeName.ticketActivate,
        component: ticketActivate,
        children: []
    }
} else {
    addRouterticketReport16 = {
        path: '/ticketActivate',
        iconCls: 'fa el-icon-document-checked',
        name: routeName.ticketActivate,
        component: ticketActivate,
        hidden: true,
        children: []
    }
}
let Stockholder1 = storage.getItem("Stockholder1");
let Stockholder2 = storage.getItem("Stockholder2");
let Stockholder3 = storage.getItem("Stockholder3");
let Stockholder4 = storage.getItem("Stockholder4");

let addRouterStockholder2 = {};
let addRouterStockholder3 = {};
let addRouterStockholder4 = {};
if (Stockholder2 == 1) {
    addRouterStockholder2 = {
        path: '/Shareholder',
        iconCls: 'fa el-icon-copy-document',
        name: routeName.Shareholder,
        component: Shareholder,
        children: []
    }
} else {
    addRouterStockholder2 = {
        path: 'Shareholder',
        iconCls: 'fa el-icon-copy-document',
        name: routeName.Shareholder,
        component: Shareholder,
        hidden: true,
        children: []
    }
}

if (Stockholder3 == 1) {
    addRouterStockholder3 = {
        path: '/Share',
        iconCls: 'fa el-icon-pie-chart',
        name: routeName.Share,
        component: Share,
        children: []
    }
} else {
    addRouterStockholder3 = {
        path: 'Share',
        iconCls: 'fa el-icon-pie-chart',
        name: routeName.Share,
        component: Share,
        hidden: true,
        children: []
    }
}
if (Stockholder4 == 1) {
    addRouterStockholder4 = {
        path: '/Statement',
        iconCls: 'fa el-icon-money',
        name: routeName.Statement,
        component: Statement,
        children: []
    }
} else {
    addRouterStockholder4 = {
        path: 'Statement',
        iconCls: 'fa el-icon-money',
        name: routeName.Statement,
        component: Statement,
        hidden: true,
        children: []
    }
}


let Warehouse1 = storage.getItem("Warehouse1");
let Warehouse2 = storage.getItem("Warehouse2");
let Warehouse3 = storage.getItem("Warehouse3");

let addRouterWarehouse2 = {};
let addRouterWarehouse3 = {};



if (Warehouse2 == 1) {
    addRouterWarehouse2 = {
        path: '/Entry',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.Entry,
        component: Entry,
        children: []
    }
} else {
    addRouterWarehouse2 = {
        path: 'Entry',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.Entry,
        component: Entry,
        hidden: true,
        children: []
    }
}
if (Warehouse3 == 1) {
    addRouterWarehouse3 = {
        path: '/Ticket_Inventory',
        iconCls: 'fa el-icon-s-data',
        name: routeName.Ticket_Inventory,
        component: Ticket_Inventory,
        children: []
    }
} else {
    addRouterWarehouse3 = {
        path: '/Ticket_Inventory',
        iconCls: 'fa el-icon-s-data',
        name: routeName.Ticket_Inventory,
        component: Ticket_Inventory,
        hidden: true,
        children: []
    }
}

let ticketCollection1 = storage.getItem("ticketCollection1");
let ticketCollection2 = storage.getItem("ticketCollection2");
let ticketCollection3 = storage.getItem("ticketCollection3");
let ticketCollection4 = storage.getItem("ticketCollection4");
let ticketCollection5 = storage.getItem("ticketCollection5");
let addRouterTicketCollection2 = {};
let addRouterTicketCollection3 = {};
let addRouterTicketCollection4 = {};
let addRouterTicketCollection5 = {};

if (ticketCollection2 == 1) {
    addRouterTicketCollection2 = {
        path: '/ticketWarehouseManagement',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.ticketWarehouseManagement,
        component: ticketWarehouseManagement,
        children: []
    }
} else {
    addRouterTicketCollection2 = {
        path: '/ticketWarehouseManagement',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.ticketWarehouseManagement,
        component: ticketWarehouseManagement,
        hidden: true,
        children: []
    }
}

if (ticketCollection3 == 1) {
    addRouterTicketCollection3 = {
        path: '/ticketCollectionManagement',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.ticketCollectionManagement,
        component: ticketCollectionManagement,
        children: []
    }
} else {
    addRouterTicketCollection3 = {
        path: '/ticketCollectionManagement',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.ticketCollectionManagement,
        component: ticketCollectionManagement,
        hidden: true,
        children: []
    }
}

if (ticketCollection4 == 1) {
    addRouterTicketCollection4 = {
        path: '/returnManagement',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.returnManagement,
        component: returnManagement,
        children: []
    }
} else {
    addRouterTicketCollection4 = {
        path: '/returnManagement',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.returnManagement,
        component: returnManagement,
        hidden: true,
        children: []
    }
}
if (ticketCollection5 == 1) {
    addRouterTicketCollection5 = {
        path: '/dataStatistics',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.dataStatistics,
        component: dataStatistics,
        children: []
    }
} else {
    addRouterTicketCollection5 = {
        path: '/dataStatistics',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.dataStatistics,
        component: dataStatistics,
        hidden: true,
        children: []
    }
}

let passenger1 = storage.getItem("passenger1");
let passenger2 = storage.getItem("passenger2");
let passenger3 = storage.getItem("passenger3");

let addRouterpassenger2 = {};
let addRouterpassenger3 = {};



if (passenger2 == 1) {
    addRouterpassenger2 = {
        path: '/camera',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.camera,
        component: camera,
        children: []
    }
} else {
    addRouterpassenger2 = {
        path: 'camera',
        iconCls: 'fa el-icon-s-finance',
        name: routeName.camera,
        component: camera,
        hidden: true,
        children: []
    }
}
if (passenger3 == 1) {
    addRouterpassenger3 = {
        path: '/statistics',
        iconCls: 'fa el-icon-s-data',
        name: routeName.statistics,
        component: statistics,
        children: []
    }
} else {
    addRouterpassenger3 = {
        path: '/statistics',
        iconCls: 'fa el-icon-s-data',
        name: routeName.statistics,
        component: statistics,
        hidden: true,
        children: []
    }
}



let goods1 = storage.getItem("goods1");
let goods2 = storage.getItem("goods2");
let goods3 = storage.getItem("goods3");
let goods4 = storage.getItem("goods4");
let goods5 = storage.getItem("goods5");
let goods6 = storage.getItem("goods6");
let goods7 = storage.getItem("goods7");
let goods8 = storage.getItem("goods8");
let addRoutergoods2 = {};
let addRoutergoods3 = {};
let addRoutergoods4 = {};
let addRoutergoods5 = {};
let addRoutergoods6 = {};
let addRoutergoods7 = {};
let addRoutergoods8 = {};
if (goods2 == 1) {
    addRoutergoods2 = {
        path: '/shops',
        iconCls: 'fa el-icon-s-shop',
        name: routeName.shops,
        component: shops,
        children: []
    }
} else {
    addRoutergoods2 = {
        path: '/shops',
        iconCls: 'fa el-icon-s-shop',
        name: routeName.shops,
        component: shops,
        hidden: true,
        children: []
    }
}
if (goods3 == 1) {
    addRoutergoods3 = {
        path: '/gatalogue',
        iconCls: 'fa el-icon-s-grid',
        name: routeName.gatalogue,
        component: gatalogue,
        children: []
    }
} else {
    addRoutergoods3 = {
        path: '/gatalogue',
        iconCls: 'fa el-icon-s-grid',
        name: routeName.gatalogue,
        component: gatalogue,
        hidden: true,
        children: []
    }
}
if (goods4 == 1) {
    addRoutergoods4 = {
        path: '/commodity',
        iconCls: 'fa el-icon-s-order',
        name: routeName.commodity,
        component: commodity,
        children: []
    }
} else {
    addRoutergoods4 = {
        path: '/commodity',
        iconCls: 'fa el-icon-s-order',
        name: routeName.commodity,
        component: commodity,
        hidden: true,
        children: []
    }
}

if (goods5 == 1) {
    addRoutergoods5 = {
        path: '/goodsloading',
        iconCls: 'fa el-icon-s-unfold',
        name: routeName.goodsloading,
        component: goodsloading,
        children: []
    }
} else {
    addRoutergoods5 = {
        path: '/goodsloading',
        iconCls: 'fa el-icon-s-unfold',
        name: routeName.goodsloading,
        component: goodsloading,
        hidden: true,
        children: []
    }
}
if (goods6 == 1) {
    addRoutergoods6 = {
        path: '/Inventory',
        iconCls: 'fa el-icon-s-management',
        name: routeName.Inventory,
        component: Inventory,
        children: []
    }
} else {
    addRoutergoods6 = {
        path: '/Inventory',
        iconCls: 'fa el-icon-s-management',
        name: routeName.Inventory,
        component: Inventory,
        hidden: true,
        children: []
    }
}
if (goods7 == 1) {
    addRoutergoods7 = {
        path: '/Commoditysales',
        iconCls: 'fa el-icon-s-flag',
        name: routeName.Commoditysales,
        component: Commoditysales,
        children: []
    }
} else {
    addRoutergoods7 = {
        path: '/Commoditysales',
        iconCls: 'fa el-icon-s-flag',
        name: routeName.Commoditysales,
        component: Commoditysales,
        hidden: true,
        children: []
    }
}
if (goods8 == 1) {
    addRoutergoods8 = {
        path: '/Salesdetails',
        iconCls: 'fa el-icon-s-cooperation',
        name: routeName.Salesdetails,
        component: Salesdetails,
        children: []
    }
} else {
    addRoutergoods8 = {
        path: '/Salesdetails',
        iconCls: 'fa el-icon-s-cooperation',
        name: routeName.Salesdetails,
        component: Salesdetails,
        hidden: true,
        children: []
    }
}



let ticketInput1 = storage.getItem("ticketInput1");
let ticketInput2 = storage.getItem("ticketInput2");
let ticketInput3 = storage.getItem("ticketInput3");
let addRouterticketInput2 = {};
let addRouterticketInput3 = {};
if (ticketInput2 == 1) {
    addRouterticketInput2 = {
        path: '/ticketType',
        iconCls: 'fa el-icon-discount',
        name: routeName.ticketType,
        component: ticketType,
        children: []
    }
} else {
    addRouterticketInput2 = {
        path: '/ticketType',
        iconCls: 'fa el-icon-discount',
        name: routeName.ticketType,
        component: ticketType,
        hidden: true,
        children: []
    }
}
if (ticketInput3 == 1) {
    addRouterticketInput3 = {
        path: '/ticketCommodity',
        iconCls: 'fa el-icon-price-tag',
        name: routeName.ticketCommodity,
        component: ticketCommodity,
        children: []
    }
} else {
    addRouterticketInput3 = {
        path: '/ticketCommodity',
        iconCls: 'fa el-icon-price-tag',
        name: routeName.ticketCommodity,
        component: ticketCommodity,
        hidden: true,
        children: []
    }
}

let ticketsystem1 = storage.getItem("ticketsystem1");
let ticketsystem2 = storage.getItem("ticketsystem2");
let ticketsystem3 = storage.getItem("ticketsystem3");
let ticketsystem4 = storage.getItem("ticketsystem4");
let ticketsystem5 = storage.getItem("ticketsystem5");
let ticketsystem6 = storage.getItem("ticketsystem6");
let ticketsystem7 = storage.getItem("ticketsystem7");
let addRouterticketsystem2 = {};
let addRouterticketsystem3 = {};
let addRouterticketsystem4 = {};
let addRouterticketsystem5 = {};
let addRouterticketsystem6 = {};
let addRouterticketsystem7 = {};

if (ticketsystem2 == 1) {
    addRouterticketsystem2 = {
        path: '/ticketWechat',
        iconCls: 'fa el-icon-postcard',
        name: routeName.ticketWechat,
        component: ticketWechat,
        hidden: false,
        children: []
    }
} else {
    addRouterticketsystem2 = {
        path: '/ticketWechat',
        iconCls: 'fa el-icon-postcard',
        name: routeName.ticketWechat,
        component: ticketWechat,
        hidden: true,
        children: []
    }
}

if (ticketsystem3 == 1) {
    addRouterticketsystem3 = {
        path: '/ticketAlipay',
        iconCls: 'fa el-icon-data-board',
        name: routeName.ticketAlipay,
        component: ticketAlipay,
        hidden: false,
        children: []
    }
} else {
    addRouterticketsystem3 = {
        path: '/ticketAlipay',
        iconCls: 'fa el-icon-data-board',
        name: routeName.ticketAlipay,
        component: ticketAlipay,
        hidden: true,
        children: []
    }
}
if (ticketsystem4 == 1) {
    addRouterticketsystem4 = {
        path: '/ticketDatabase',
        iconCls: 'fa el-icon-warning',
        name: routeName.ticketDatabase,
        component: ticketDatabase,
        hidden: false,
        children: []
    }
} else {
    addRouterticketsystem4 = {
        path: '/ticketDatabase',
        iconCls: 'fa el-icon-warning',
        name: routeName.ticketDatabase,
        component: ticketDatabase,
        hidden: true,
        children: []
    }
}

if (ticketsystem5 == 1) {
    addRouterticketsystem5 = {
        path: '/ticketInformation',
        iconCls: 'fa el-icon-s-help',
        name: routeName.ticketInformation,
        component: ticketInformation,
        hidden: false,
        children: []
    }
} else {
    addRouterticketsystem5 = {
        path: '/ticketInformation',
        iconCls: 'fa el-icon-s-help',
        name: routeName.ticketInformation,
        component: ticketInformation,
        hidden: true,
        children: []
    }
}

if (ticketsystem6 == 1) {
    addRouterticketsystem6 = {
        path: '/ticketLog',
        iconCls: 'fa el-icon-document-copy',
        name: routeName.ticketLog,
        component: ticketLog,
        hidden: false,
        children: []
    }
} else {
    addRouterticketsystem6 = {
        path: '/ticketLog',
        iconCls: 'fa el-icon-document-copy',
        name: routeName.ticketLog,
        component: ticketLog,
        hidden: true,
        children: []
    }
}
if (ticketsystem7 == 1) {
    addRouterticketsystem7 = {
        path: '/EquipmentUpgrade',
        iconCls: 'fa el-icon-document-copy',
        name: routeName.EquipmentUpgrade,
        component: EquipmentUpgrade,
        hidden: false,
        children: []
    }
} else {
    addRouterticketsystem7 = {
        path: '/EquipmentUpgrade',
        iconCls: 'fa el-icon-document-copy',
        name: routeName.EquipmentUpgrade,
        component: EquipmentUpgrade,
        hidden: true,
        children: []
    }
}
/* 信息发布 */

let ticketrelease1 = storage.getItem("ticketrelease1");
let ticketrelease2 = storage.getItem("ticketrelease2");
let ticketrelease3 = storage.getItem("ticketrelease3");
let ticketrelease4 = storage.getItem("ticketrelease4");
let ticketrelease5 = storage.getItem("ticketrelease5");

let addRouterticketrelease2 = {};
let addRouterticketrelease3 = {};
let addRouterticketrelease4 = {};
let addRouterticketrelease5 = {};

if (ticketrelease2 == 1) {
    addRouterticketrelease2 = {
        path: '/programRelease',
        iconCls: 'fa el-icon-document-copy',
        name: routeName.programRelease,
        component: programRelease,
        hidden: false,
        children: []
    }
} else {
    addRouterticketrelease2 = {
        path: '/programRelease',
        iconCls: 'fa el-icon-document-copy',
        name: routeName.programRelease,
        component: programRelease,
        hidden: true,
        children: []
    }
}
if (ticketrelease3 == 1) {
    addRouterticketrelease3 = {
        path: '/graphicRelease',
        iconCls: 'fa el-icon-picture-outline-round',
        name: routeName.graphicRelease,
        component: graphicRelease,
        hidden: false,
        children: []
    }
} else {
    addRouterticketrelease3 = {
        path: '/graphicRelease',
        iconCls: 'fa el-icon-picture-outline-round',
        name: routeName.graphicRelease,
        component: graphicRelease,
        hidden: true,
        children: []
    }
}
if (ticketrelease4 == 1) {
    addRouterticketrelease4 = {
        path: '/contentRelease',
        iconCls: 'fa el-icon-s-cooperation',
        name: routeName.contentRelease,
        component: contentRelease,
        hidden: false,
        children: []
    }
} else {
    addRouterticketrelease4 = {
        path: '/contentRelease',
        iconCls: 'fa el-icon-s-cooperation',
        name: routeName.contentRelease,
        component: contentRelease,
        hidden: true,
        children: []
    }
}
if (ticketrelease5 == 1) {
    addRouterticketrelease5 = {
        path: '/dataRelease',
        iconCls: 'fa el-icon-s-platform',
        name: routeName.dataRelease,
        component: dataRelease,
        hidden: false,
        children: []
    }
} else {
    addRouterticketrelease5 = {
        path: '/dataRelease',
        iconCls: 'fa el-icon-s-platform',
        name: routeName.dataRelease,
        component: dataRelease,
        hidden: true,
        children: []
    }
}
/* 旅行社管理 */

let travelAgencyManagement1 = storage.getItem("travelAgencyManagement1");
let travelAgencyManagement2 = storage.getItem("travelAgencyManagement2");
let travelAgencyManagement3 = storage.getItem("travelAgencyManagement3");
let travelAgencyManagement4 = storage.getItem("travelAgencyManagement4");
let travelAgencyManagement5 = storage.getItem("travelAgencyManagement5");
let travelAgencyManagement6 = storage.getItem("travelAgencyManagement6");
let travelAgencyManagement7 = storage.getItem("travelAgencyManagement7");
let travelAgencyManagement8 = storage.getItem("travelAgencyManagement8");

let addRoutertravelAgencyManagement2 = {};
let addRoutertravelAgencyManagement3 = {};
let addRoutertravelAgencyManagement4 = {};
let addRoutertravelAgencyManagement5 = {};
let addRoutertravelAgencyManagement6 = {};
let addRoutertravelAgencyManagement7 = {};
// let addRoutertravelAgencyManagement8 = {};


if (travelAgencyManagement2 == 1) {
    addRoutertravelAgencyManagement2 = {
        path: '/travelAgencyManagement',
        iconCls: 'fa el-icon-office-building',
        name: routeName.travelAgencyManagement,
        component: travelAgencyManagement,
        hidden: false,
        children: []
    }
} else {
    addRoutertravelAgencyManagement2 = {
        path: '/travelAgencyManagement',
        iconCls: 'fa el-icon-office-building',
        name: routeName.travelAgencyManagement,
        component: travelAgencyManagement,
        hidden: true,
        children: []
    }
}
if (travelAgencyManagement3 == 1) {
    addRoutertravelAgencyManagement3 = {
        path: '/ticketTypeManagement',
        iconCls: 'fa el-icon-s-ticket',
        name: routeName.ticketTypeManagement,
        component: ticketTypeManagement,
        hidden: false,
        children: []
    }
} else {
    addRoutertravelAgencyManagement3 = {
        path: '/ticketTypeManagement',
        iconCls: 'fa el-icon-s-ticket',
        name: routeName.ticketTypeManagement,
        component: ticketTypeManagement,
        hidden: true,
        children: []
    }
}
if (travelAgencyManagement4 == 1) {
    addRoutertravelAgencyManagement4 = {
        path: '/orderManagement',
        iconCls: 'fa el-icon-document-checked',
        name: routeName.orderManagement,
        component: orderManagement,
        hidden: false,
        children: []
    }
} else {
    addRoutertravelAgencyManagement4 = {
        path: '/orderManagement',
        iconCls: 'fa el-icon-document-checked',
        name: routeName.orderManagement,
        component: orderManagement,
        hidden: true,
        children: []
    }
}
if (travelAgencyManagement5 == 1) {
    addRoutertravelAgencyManagement5 = {
        path: '/rechargeManagement',
        iconCls: 'fa el-icon-money',
        name: routeName.rechargeManagement,
        component: rechargeManagement,
        hidden: false,
        children: []
    }
} else {
    addRoutertravelAgencyManagement5 = {
        path: '/rechargeManagement',
        iconCls: 'fa el-icon-money',
        name: routeName.rechargeManagement,
        component: rechargeManagement,
        hidden: true,
        children: []
    }
}
if (travelAgencyManagement6 == 1) {
    addRoutertravelAgencyManagement6 = {
        path: '/userManagement',
        iconCls: 'fa el-icon-user-solid',
        name: routeName.userManagement,
        component: userManagement,
        hidden: false,
        children: []
    }
} else {
    addRoutertravelAgencyManagement6 = {
        path: '/userManagement',
        iconCls: 'fa el-icon-user-solid',
        name: routeName.userManagement,
        component: userManagement,
        hidden: true,
        children: []
    }
}
if (travelAgencyManagement7 == 1) {
    addRoutertravelAgencyManagement7 = {
        path: '/financialStatements',
        iconCls: 'el-icon-document-copy',
        name: routeName.financialStatements,
        component: financialStatements,
        hidden: false,
        children: []
    }
} else {
    addRoutertravelAgencyManagement7 = {
        path: '/financialStatements',
        iconCls: 'el-icon-document-copy',
        name: routeName.financialStatements,
        component: financialStatements,
        hidden: true,
        children: []
    }
}
// if (travelAgencyManagement8 == 1) {
//     addRoutertravelAgencyManagement8 = {
//         path: '/test',
//         iconCls: 'el-icon-bangzhu',
//         name: routeName.test,
//         component: test,
//         hidden: false,
//         children: []
//     }
// } else {
//     addRoutertravelAgencyManagement8 = {
//         path: '/test',
//         iconCls: 'el-icon-bangzhu',
//         name: routeName.test,
//         component: test,
//         hidden: true,
//         children: []
//     }
// }



/*售票*/
let sellticket1 = storage.getItem("sellticket1");
let sellticket2 = storage.getItem("sellticket2");
let sellticket3 = storage.getItem("sellticket3");
let sellticket4 = storage.getItem("sellticket4");
let sellticket5 = storage.getItem("sellticket5");
let sellticket6 = storage.getItem("sellticket6");
let sellticket7 = storage.getItem("sellticket7");
let sellticket8 = storage.getItem("sellticket8");
let sellticket9 = storage.getItem("sellticket9");
let sellticket10 = storage.getItem("sellticket10");
let sellticket11 = storage.getItem("sellticket11");
let sellticket12 = storage.getItem("sellticket12");
let sellticket13 = storage.getItem("sellticket13");
let sellticket14 = storage.getItem("sellticket14");
let sellticket15 = storage.getItem("sellticket15");
let sellticket16 = storage.getItem("sellticket16");

let ticketStatements1 = storage.getItem("ticketStatements1");

let datalist1 = storage.getItem("datalist1");

let travelAgencyMenu1 = storage.getItem("travelAgencyMenu1");
let travelAgencyMenu2 = storage.getItem("travelAgencyMenu2");
let travelAgencyMenu3 = storage.getItem("travelAgencyMenu3");
let travelAgencyMenu4 = storage.getItem("travelAgencyMenu4");



//-------------------------定义路由-------------------------------------------//
let addRouter = [];
if (travelAgencyMenu1 == 1) {
    addRouter.push({
        path: '/index', // 主页
        iconCls: 'fa fa-dashboard',
        name: routeName.importOrder,
        component: Layout,
        alone: true,
        children: [
            {
                path: '/index',
                iconCls: 'fa el-icon-document-add',
                name: routeName.importOrder,
                component: importOrder,
                hidden: false,
                children: []
            }
        ]
    })
} else {
    addRouter.push({
        path: '/index', // 主页
        iconCls: 'fa fa-dashboard',
        name: routeName.home,
        component: Layout,
        alone: true,
        children: [{
            path: '/index',
            iconCls: 'fa fa-dashboard',
            name: '主页',
            component: mainIndex,
            children: []
        }]
    })
}
if (ticketSetting1 == 1) {
    addRouter.push({
        path: '/', //票务设置
        iconCls: 'fa el-icon-setting',
        name: routeName.ticketSetting,
        hidden: false,
        component: Layout,
        children: [
            addRouterticketSetting2, addRouterticketSetting3, addRouterticketSetting4, addRouterticketSetting5, addRouterticketSetting6
        ]
    })
}
if (ticketManagement1 == 1) {
    addRouter.push({
        path: '/', //票务设置
        iconCls: 'fa el-icon-s-platform',
        name: routeName.ticketManagement,
        hidden: false,
        component: Layout,
        children: [
            addRouterticketManagement2, addRouterticketManagement3, addRouterticketManagement4, addRouterticketManagement5,
            addRouterticketManagement6, addRouterticketManagement7, addRouterticketManagement8, addRouterticketManagement16, addRouterticketManagement9,
            addRouterticketManagement10, addRouterticketManagement11, addRouterticketManagement12, addRoutersetting5,
            addRouterticketManagement14, addRouterticketManagement15
        ]
    })
}
if (setting1 == 1) {
    addRouter.push({
        path: '/', // 权限管理
        iconCls: 'fa el-icon-wallet',
        name: routeName.setting,
        hidden: false,
        component: Layout,
        children: [
            addRoutersetting3, addRoutersetting4
        ]
    })
}

if (ticketVenue1 == 1) {
    addRouter.push({
        path: '/', // 场馆管理
        iconCls: 'fa el-icon-office-building',
        name: routeName.ticketVenue,
        hidden: false,
        component: Layout,
        children: [
            addRouterticketVenue2, addRouterticketVenue3
        ]
    })
}
if (ticketReport1 == 1) {
    addRouter.push({
        path: '/', // 查询报表
        iconCls: 'fa el-icon-pie-chart',
        name: routeName.ticketReport,
        hidden: false,
        component: Layout,
        children: [
            addRouterticketReport2, addRouterticketReport3, addRouterticketReport4,
            addRouterticketReport5, addRouterticketReport6,addRouterticketReport16,addRouterticketReport7,
            addRouterticketReport8, addRouterticketReport9, addRouterticketReport10,
            addRouterticketReport11, addRouterticketReport12, addRouterticketReport13, addRouterticketReport14, addRouterticketReport15
        ]
    })
}
if (Stockholder1 == 1) {
    addRouter.push({
        path: '/', //
        iconCls: 'fa el-icon-takeaway-box',
        name: routeName.Stockholder,
        hidden: false,
        component: Layout,
        children: [
            addRouterStockholder2, addRouterStockholder3, addRouterStockholder4,

        ]
    })
}

if (Warehouse1 == 1) {
    addRouter.push({
        path: '/', //
        iconCls: 'fa el-icon-postcard',
        name: routeName.Warehouse,
        hidden: false,
        component: Layout,
        children: [
            addRouterWarehouse2, addRouterWarehouse3,
        ]
    })
}

if (ticketCollection1 == 1) {
    addRouter.push({
        path: '/',
        iconCls: 'fa el-icon-postcard',
        name: routeName.ticketCollection,
        hidden: false,
        component: Layout,
        children: [
            addRouterTicketCollection2, addRouterTicketCollection3, addRouterTicketCollection4, addRouterTicketCollection5
        ]
    })
}

if (goods1 == 1) {
    addRouter.push({
        path: '/', //
        iconCls: 'fa el-icon-s-data',
        name: routeName.goods,
        hidden: false,
        component: Layout,
        children: [
            addRoutergoods2, addRoutergoods3, addRoutergoods4, addRoutergoods5, addRoutergoods6, addRoutergoods7, addRoutergoods8,

        ]
    })
}

if (ticketInput1 == 1) {
    addRouter.push({
        path: '/', //
        iconCls: 'fa el-icon-s-ticket',
        name: routeName.ticketInput,
        hidden: false,
        component: Layout,
        children: [
            addRouterticketInput2, addRouterticketInput3
        ]
    })
}

if (passenger1 == 1) {
    addRouter.push({
        path: '/', // 客流统计
        iconCls: 'fa el-icon-s-grid',
        name: routeName.passenger,
        hidden: false,
        component: Layout,
        children: [
            addRouterpassenger2, addRouterpassenger3
        ]
    })
}


if (ticketsystem1 == 1) {
    addRouter.push({
        path: '/', // 系统信息
        iconCls: 'fa el-icon-coin',
        name: routeName.ticketsystem,
        hidden: false,
        component: Layout,
        children: [
            addRouterticketsystem2, addRouterticketsystem3, addRouterticketsystem4, addRouterticketsystem5, addRouterticketsystem6, addRouterticketsystem7
        ]
    })
}

if (ticketrelease1 == 1) {
    addRouter.push({
        path: '/', // 发布
        iconCls: 'fa el-icon-video-camera',
        name: routeName.release,
        hidden: false,
        component: Layout,
        children: [
            addRouterticketrelease2, addRouterticketrelease3, addRouterticketrelease4, addRouterticketrelease5

        ]
    })
}

if (travelAgencyManagement1 == 1) {
    addRouter.push({
        path: '/', //旅行社
        iconCls: 'fa el-icon-suitcase-1',
        name: routeName.travelAgencyManagement,
        hidden: false,
        component: Layout,
        children: [
            addRoutertravelAgencyManagement2, addRoutertravelAgencyManagement3, addRoutertravelAgencyManagement4, addRoutertravelAgencyManagement5, addRoutertravelAgencyManagement6,addRoutertravelAgencyManagement7

        ]
    })
}

if (ticketStatements1 == 1) {
    addRouter.push({
        path: '/ticketStatements', // 财务报表
        iconCls: 'el-icon-document-copy',
        name: routeName.ticketStatements,
        alone: true,
        component: Layout,
        children: [{
            path: '/ticketStatements',
            iconCls: 'fa el-icon-document-copy',
            name: routeName.ticketStatements,
            component: ticketStatements,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/ticketStatements', // 财务报表
        iconCls: 'el-icon-document-copy',
        name: routeName.ticketStatements,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}

// if (travelAgencyMenu2 == 1) {
//     addRouter.push({
//         path: '/importOrder', // 导入下单
//         iconCls: 'el-icon-document-add',
//         name: routeName.importOrder,
//         alone: true,
//         component: Layout,
//         children: [{
//             path: '/importOrder',
//             iconCls: 'fa el-icon-document-add',
//             name: routeName.importOrder,
//             component: importOrder,
//             hidden: false,
//             children: []
//         }]
//     })
// } else {
//     addRouter.push({
//         path: '/importOrder', // 导入下单
//         iconCls: 'el-icon-document-add',
//         name: routeName.importOrder,
//         alone: true,
//         component: Layout,
//         hidden: true,
//         children: []
//     })
// }
if (travelAgencyMenu3 == 1) {
    addRouter.push({
        path: '/travelAgencyOrderManagement_travelAgency', // 订单管理
        iconCls: 'el-icon-document-checked',
        name: routeName.travelAgencyOrderManagement_travelAgency,
        alone: true,
        component: Layout,
        children: [{
            path: '/travelAgencyOrderManagement_travelAgency',
            iconCls: 'fa el-icon-document-checked',
            name: routeName.travelAgencyOrderManagement_travelAgency,
            component: travelAgencyOrderManagement_travelAgency,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/travelAgencyOrderManagement_travelAgency', // 订单管理
        iconCls: 'el-icon-document-checked',
        name: routeName.travelAgencyOrderManagement_travelAgency,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (travelAgencyMenu4 == 1) {
    addRouter.push({
        path: '/travelAgencyRechargeManagement', // 充值管理
        iconCls: 'el-icon-money',
        name: routeName.travelAgencyRechargeManagement,
        alone: true,
        component: Layout,
        children: [{
            path: '/travelAgencyRechargeManagement',
            iconCls: 'fa el-icon-money',
            name: routeName.travelAgencyRechargeManagement,
            component: travelAgencyRechargeManagement,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/travelAgencyOrderManagement_travelAgency', // 充值管理
        iconCls: 'el-icon-money',
        name: routeName.travelAgencyOrderManagement_travelAgency,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}

if (datalist1 == 1) {
    addRouter.push({
        path: '/datalist', // 数据中心
        iconCls: 'el-icon-s-help',
        name: routeName.datalist,
        alone: true,
        component: Layout,
        children: [{
            path: '/datalist',
            iconCls: 'el-icon-s-help',
            name: routeName.datalist,
            component: datalist,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/datalist', // 数据中心
        iconCls: 'el-icon-s-help',
        name: routeName.datalist,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}



if (sellticket1 == 1) {
    addRouter.push({
        path: '/sellPrintTickets', // 打印售票
        iconCls: 'fa el-icon-printer',
        name: routeName.PrintTickets,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellPrintTickets',
            iconCls: 'fa fa el-icon-printer',
            name: routeName.sellPrintTickets,
            component: sellPrintTickets,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellPrintTickets', // 打印售票
        iconCls: 'fa el-icon-printer',
        name: routeName.PrintTickets,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket13 == 1) {
    addRouter.push({
        path: '/sellPrintTicketsgoods', // 购物车售票
        iconCls: 'fa el-icon-printer',
        name: routeName.sellPrintTicketsgoods,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellPrintTicketsgoods',
            iconCls: 'fa fa el-icon-printer',
            name: routeName.sellPrintTicketsgoods,
            component: sellPrintTicketsgoods,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellPrintTicketsgoods', // 打印售票
        iconCls: 'fa el-icon-printer',
        name: routeName.sellPrintTicketsgoods,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}


if (sellticket2 == 1) {
    addRouter.push({
        path: '/sellScanningTicketing', // 扫描售票
        iconCls: 'el-icon-wallet',
        name: routeName.ScanningTicketing,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellScanningTicketing',
            iconCls: 'fa el-icon-wallet',
            name: routeName.sellScanningTicketing,
            component: sellScanningTicketing,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellScanningTicketing', // 扫描售票
        iconCls: 'el-icon-wallet',
        name: routeName.sellScanningTicketing,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket3 == 1) {
    addRouter.push({
        path: '/sellMembershipCard', // 会员卡
        iconCls: 'el-icon-bank-card',
        name: routeName.MembershipCard,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellMembershipCard',
            iconCls: 'fa el-icon-bank-card',
            name: routeName.sellMembershipCard,
            component: sellMembershipCard,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellMembershipCard', // 会员卡
        iconCls: 'el-icon-bank-card',
        name: routeName.sellMembershipCard,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket4 == 1) {
    addRouter.push({
        path: '/sellStoredCard', // 储值卡
        iconCls: 'el-icon-postcard',
        name: routeName.StoredCard,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellStoredCard',
            iconCls: 'fa el-icon-postcard',
            name: routeName.sellStoredCard,
            component: sellStoredCard,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellStoredCard', //储值卡
        iconCls: 'el-icon-postcard',
        name: routeName.sellStoredCard,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket12 == 1) {
    addRouter.push({
        path: '/scan', // 扫描
        iconCls: 'el-icon-data-line',
        name: routeName.scan,
        alone: true,
        component: Layout,
        children: [{
            path: '/scan',
            iconCls: 'fa el-icon-data-line',
            name: routeName.scan,
            component: scan,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/scan', //扫描
        iconCls: 'el-icon-data-line',
        name: routeName.scan,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}

if (sellticket11 == 1) {
    addRouter.push({
        path: '/sellgoods', // 商品
        iconCls: 'el-icon-s-cooperation',
        name: routeName.sellgoods,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellgoods',
            iconCls: 'fa el-icon-s-cooperation',
            name: routeName.sellgoods,
            component: sellgoods,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellgoods', //商品
        iconCls: 'el-icon-s-cooperation',
        name: routeName.sellgoods,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket15 == 1) {
    addRouter.push({
        path: '/annualCardActivation', // 年卡激活
        iconCls: 'el-icon-s-cooperation',
        name: routeName.annualCardActivation,
        alone: true,
        component: Layout,
        children: [{
            path: '/annualCardActivation',
            iconCls: 'fa el-icon-s-cooperation',
            name: routeName.annualCardActivation,
            component: annualCardActivation,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/annualCardActivation', //年卡激活
        iconCls: 'el-icon-s-cooperation',
        name: routeName.annualCardActivation,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}

if (sellticket9 == 1) {
    addRouter.push({
        path: '/sellMemberrenewal', // 续费
        iconCls: 'el-icon-postcard',
        name: routeName.Memberrenewal,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellMemberrenewal',
            iconCls: 'fa el-icon-postcard',
            name: routeName.Memberrenewal,
            component: sellMemberrenewal,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellMemberrenewal', //续费
        iconCls: 'el-icon-postcard',
        name: routeName.Memberrenewal,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket5 == 1) {
    addRouter.push({
        path: '/sellRefund', // 退票
        iconCls: 'el-icon-money',
        name: routeName.Refund,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellRefund',
            iconCls: 'fa el-icon-money',
            name: routeName.sellRefund,
            component: sellRefund,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellRefund', // 退票
        iconCls: 'el-icon-money',
        name: routeName.sellRefund,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket10 == 1) {
    addRouter.push({
        path: '/sellDifference', //
        iconCls: 'el-icon-money',
        name: routeName.sellDifference,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellDifference',
            iconCls: 'fa el-icon-money',
            name: routeName.sellDifference,
            component: sellDifference,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellDifference', // 退票
        iconCls: 'el-icon-money',
        name: routeName.sellDifference,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}

if (sellticket6 == 1) {
    addRouter.push({
        path: '/sellCollection', // 取票
        iconCls: 'el-icon-mobile',
        name: routeName.Collection,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellCollection',
            iconCls: 'fa el-icon-mobile',
            name: routeName.Collection,
            component: sellCollection,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellCollection', //取票
        iconCls: 'el-icon-mobile',
        name: routeName.sellCollection,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket7 == 1) {
    addRouter.push({
        path: '/sellRecord', // 当班记录
        iconCls: 'el-icon-tickets',
        name: routeName.Record,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellRecord',
            iconCls: 'fa el-icon-document-copy',
            name: routeName.sellRecord,
            component: sellRecord,
            hidden: false,
            children: []
        }

        ]
    })
} else {
    addRouter.push({
        path: '/sellRecord', // 当班记录
        iconCls: 'el-icon-tickets',
        name: routeName.sellRecord,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}
if (sellticket16 == 1) {
    addRouter.push({
        path: '/travelAgencyOrderManagement', // 当班记录
        iconCls: 'el-icon-s-order',
        name: routeName.travelAgencyOrderManagement,
        alone: true,
        component: Layout,
        children: [{
            path: '/travelAgencyOrderManagement',
            iconCls: 'fa el-icon-s-order',
            name: routeName.travelAgencyOrderManagement,
            component: travelAgencyOrderManagement,
            hidden: false,
            children: []
        }

        ]
    })
} else {
    addRouter.push({
        path: '/sellRecord', // 当班记录
        iconCls: 'el-icon-tickets',
        name: routeName.sellRecord,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}


if (sellticket14 == 1 && travelAgencyMenu1 !== 1) {
    addRouter.push({
        path: '/ticketDetailsRecord', // 门票查询
        iconCls: 'el-icon-document-copy',
        name: routeName.ticketDetailsRecord,
        alone: true,
        component: Layout,
        children: [{
            path: '/ticketDetailsRecord',
            iconCls: 'fa el-icon-document-copy',
            name: routeName.ticketDetailsRecord,
            component: ticketDetailsRecord,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/ticketDetailsRecord', // 门票查询
        iconCls: 'el-icon-document-copy',
        name: routeName.ticketDetailsRecord,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}

if (sellticket8 == 1) {
    addRouter.push({
        path: '/sellQuery', // 门票查询
        iconCls: 'el-icon-document-copy',
        name: routeName.Query,
        alone: true,
        component: Layout,
        children: [{
            path: '/sellQuery',
            iconCls: 'fa el-icon-document-copy',
            name: routeName.sellQuery,
            component: sellQuery,
            hidden: false,
            children: []
        }]
    })
} else {
    addRouter.push({
        path: '/sellQuery', // 门票查询
        iconCls: 'el-icon-document-copy',
        name: routeName.sellQuery,
        alone: true,
        component: Layout,
        hidden: true,
        children: []
    })
}





addRouter.push({
    path: '/personalCenter', // 个人中心
    iconCls: 'el-icon-user',
    name: routeName.PersonalCenter,
    alone: true,
    component: Layout,
    children: [{
        path: '/personalCenter',
        iconCls: 'el-icon-user',
        name: routeName.personalCenter,
        component: personalCenter,
        children: []
    }]
})
addRouter.push({
    path: '*',
    redirect: '/404',
    hidden: true,
    children: []
})

export default new Router({
    mode: 'history',
    routes: defaultRouter
})
export { defaultRouter, addRouter }


// WEBPACK FOOTER //
// ./src/system/index/router/index.js